import { BaseSvgComponentProps } from 'shared/interfaces/component/baseSvgComponentProps';

type RealTimeProps = BaseSvgComponentProps;

export const Realtime = ({ style }: RealTimeProps) => (
    <svg style={style} width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_6322_7492)">
            <path d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#E3E3E1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 7V12L15 15" stroke="#E3E3E1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_6322_7492">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
